import request from '../../utils/request';

// OVO-117 — support ticketing (SupportTicket backend; NOT the legacy
// order-tickets label module).

// ─── Admin ───────────────────────────────────────────────────────────────────

export function getSupportTickets(params) {
  return request('/support-tickets', { method: 'GET', params });
}

export function getOpenTicketCount() {
  return request('/support-tickets/count', { method: 'GET' });
}

export function getAssignableUsers() {
  return request('/support-tickets/assignable', { method: 'GET' });
}

export function getSupportTicket(id) {
  return request(`/support-tickets/${id}`, { method: 'GET' });
}

export function createSupportTicket(data) {
  return request('/support-tickets', { method: 'POST', data });
}

export function updateSupportTicket(id, data) {
  return request(`/support-tickets/${id}`, { method: 'PATCH', data });
}

export function addTicketComment(id, body, internal = false) {
  return request(`/support-tickets/${id}/comments`, {
    method: 'POST',
    data: { body, internal },
  });
}

export function addTicketFile(id, fileId) {
  return request(`/support-tickets/${id}/files`, { method: 'POST', data: { fileId } });
}

// ─── Partner viewer ──────────────────────────────────────────────────────────

export function getMySupportTickets(params) {
  return request('/partners/me/support-tickets', { method: 'GET', params });
}

export function getMySupportTicket(id) {
  return request(`/partners/me/support-tickets/${id}`, { method: 'GET' });
}

export function createMySupportTicket(data) {
  return request('/partners/me/support-tickets', { method: 'POST', data });
}

export function commentMySupportTicket(id, body) {
  return request(`/partners/me/support-tickets/${id}/comments`, {
    method: 'POST',
    data: { body },
  });
}

export function reopenMySupportTicket(id) {
  return request(`/partners/me/support-tickets/${id}/reopen`, { method: 'POST' });
}

export function resolveMySupportTicket(id) {
  return request(`/partners/me/support-tickets/${id}/resolve`, { method: 'POST' });
}

// Categories mirror the backend list (driver ISSUE_TYPE values + GENERAL).
export const TICKET_CATEGORIES = [
  'GENERAL',
  // #146 — auto-created from a driver's note at the end of a stop.
  'COMMENT',
  'WRONG_CODE',
  'CUSTOMER_REQUEST',
  'DELIVERY_INFORMATION',
  'RETURN_ISSUE',
  'DELAY',
  'WRONG_ADDRESS',
  'PRODUCT_DAMAGE',
  'CLIENT_UNAVAILABLE',
  'PLANNING_ROUTE_ISSUE',
  'LOCATION_CLOSED_ACCESS_BLOCKED',
  'NOTHING_TO_COLLECT',
  'TECHNICAL_ISSUE',
  'OTHER',
];

export const TICKET_STATUSES = ['OPEN', 'IN_PROGRESS', 'RESOLVED', 'WONT_FIX'];

export const TICKET_STATUS_COLORS = {
  OPEN: 'red',
  IN_PROGRESS: 'orange',
  RESOLVED: 'green',
  WONT_FIX: 'default',
};
